import { Swiper, Navigation } from 'swiper';
import elementExists from "../../../core/utils/element-exists";

const ProductSpecSwiper = function () {
  const container = document.querySelector('.product-spec-swiper');
  if (elementExists(container)) {
    const swiperContainer = container.querySelector('.swiper');

    const swiper = new Swiper(swiperContainer, {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 1,
      loop: true,
      spaceBetween: 15,
      effect: 'fade',
      speed: 1,
      on: {
        init: function () {
          let btnNexts = container.querySelectorAll('.swiper-button-next');
          let btnPrevs = container.querySelectorAll('.swiper-button-prev');
      
          if (elementExists(btnNexts, true)) {
            btnNexts.forEach(btn => {
              btn.addEventListener('click', e => {
                swiper.slideNext();
              })
            })
          }
          if (elementExists(btnPrevs, true)) {
            btnPrevs.forEach(btn => {
              btn.addEventListener('click', e => {
                swiper.slidePrev();
              })
            })
          }
        }
      }
    })
    
    const allSwatches = document.querySelectorAll('.swatch-element')
    
    const filteredSwatches = Array.from(allSwatches).filter(swatch => {
      const ParentContainer = swatch.closest('[data-option-key="Size"]')
      return ParentContainer
    })

    if ( filteredSwatches.length > 0 ) {
      filteredSwatches.forEach((swatch, index) => {
        swatch.addEventListener('click', () => {
          swiper.slideTo(index + 1)
        })
      })
    }

  }
}

export default ProductSpecSwiper